import { Box, Grid, Text } from '@chakra-ui/react';

import { formatCurrency } from '@aslanpay/portal-common-lib';
import { getPointsValue } from 'app/utils/points';

import { PotInformationProps } from './PotInformation.types';

function PotInformation({ name, currentBalance = 0 }: PotInformationProps) {
  const potName = name || 'Company';
  const currentBalanceValue = getPointsValue(currentBalance);

  return (
    <Box bg="brand.mutedPurple" p={4} borderRadius="5px" color="white" w="100%">
      <Grid templateColumns="repeat(3, 1fr)" gap={4} w="100%">
        <Box>
          <Text
            fontFamily="MontserratVariable"
            fontSize="12px"
            fontStyle="normal"
            fontWeight="400"
            lineHeight="140%"
            color="white"
          >
            Pot
          </Text>
          <Text
            fontFamily="MontserratVariable"
            fontSize="16px"
            fontStyle="normal"
            fontWeight="500"
            lineHeight="140%"
            color="white"
          >
            {potName}
          </Text>
        </Box>
        <Box>
          <Text
            fontFamily="MontserratVariable"
            fontSize="12px"
            fontStyle="normal"
            fontWeight="400"
            lineHeight="140%"
            color="white"
          >
            Current points balance
          </Text>
          <Text
            fontFamily="MontserratVariable"
            fontSize="16px"
            fontStyle="normal"
            fontWeight="500"
            lineHeight="140%"
            color="white"
          >
            {currentBalance.toLocaleString()}
          </Text>
        </Box>
        <Box>
          <Text
            fontFamily="MontserratVariable"
            fontSize="12px"
            fontStyle="normal"
            fontWeight="400"
            lineHeight="140%"
            color="white"
          >
            Value
          </Text>
          <Text
            fontFamily="MontserratVariable"
            fontSize="16px"
            fontStyle="normal"
            fontWeight="500"
            lineHeight="140%"
            color="white"
          >
            {formatCurrency(currentBalanceValue)}
          </Text>
        </Box>
      </Grid>
    </Box>
  );
}

export default PotInformation;
